import { render, staticRenderFns } from "./BuyNewNumbers.vue?vue&type=template&id=cb854e74&scoped=true&"
import script from "./BuyNewNumbers.vue?vue&type=script&lang=js&"
export * from "./BuyNewNumbers.vue?vue&type=script&lang=js&"
import style0 from "./BuyNewNumbers.vue?vue&type=style&index=0&id=cb854e74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb854e74",
  null
  
)

export default component.exports